module.exports = __webpack_public_path__ + "img/swiper_nav2.77f6f935.png";